import { render } from "./LeadsPage.vue?vue&type=template&id=0f9e2e21"
import script from "./LeadsPage.vue?vue&type=script&lang=js"
export * from "./LeadsPage.vue?vue&type=script&lang=js"

import "./LeadsPage.vue?vue&type=style&index=0&id=0f9e2e21&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__